import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/shared/components/ui/dialog';
import { Button } from '@/shared/components/ui/button';
import { CheckCircle2 } from 'lucide-react';

interface TourCompletionModalProps {
  onClose: () => void;
}

export const TourCompletionModal = ({ onClose }: TourCompletionModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <div className="flex flex-col items-center gap-4 py-4">
            <div className="rounded-full bg-primary/10 p-4">
              <CheckCircle2 className="h-12 w-12 text-primary" />
            </div>
            <DialogTitle className="text-2xl text-center">
              {t('tour.completionModal.title')}
            </DialogTitle>
            <DialogDescription className="text-base text-center">
              {t('tour.completionModal.description')}
            </DialogDescription>
          </div>
        </DialogHeader>

        <div className="py-4 text-center">
          <p className="text-lg font-medium text-primary">
            {t('tour.completionModal.message')}
          </p>
          <p className="mt-2 text-sm text-muted-foreground">
            {t('tour.completionModal.helpText')}
          </p>
        </div>

        <DialogFooter>
          <Button onClick={onClose} className="w-full">
            {t('tour.completionModal.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
